import { useParams } from "react-router-dom"
import UsersTable from "./UsersTable"

export default function OrganizationUsersTable({ organizationId: orgId }: { organizationId: number }) {
  const { id } = useParams()
  const organizationId = Number(id) || orgId

  return (
    <UsersTable
      dataSource="organization"
      sourceId={organizationId}
      title="Area Users"
    />
  )
}

